/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_CreateInputs */

const cs_templates_empty_cta_create = /** @type {(inputs: Templates_Empty_Cta_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit šablonu`)
};

const en_templates_empty_cta_create = /** @type {(inputs: Templates_Empty_Cta_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create template`)
};

/**
* | output |
* | --- |
* | "Create template" |
*
* @param {Templates_Empty_Cta_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_create = /** @type {((inputs?: Templates_Empty_Cta_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_create(inputs)
	return cs_templates_empty_cta_create(inputs)
});